export default {
  name: 'TinyOmnyIcon',
  props: {
    width: {
      type: Number,
      default: 12
    },
    height: {
      type: Number,
      default: 12
    },
    color: {
      type: String,
      default: '#736bc9'
    }
  }
};